module.exports = __webpack_public_path__ + "img/DFW_SpikedClub.718c4191.png";